import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import { TallyFormQuestionsResponseData } from "../../types/tally";

const fetchTallyFormQuestions = async (
  formId: string,
): Promise<TallyFormQuestionsResponseData> => {
  const { data } = await createApiWithPath(
    "tally",
  ).get<TallyFormQuestionsResponseData>(`/forms/${formId}/questions`);

  return data;
};

export const useTallyFormQuestions = () => {
  return useMutation((formId: string) => fetchTallyFormQuestions(formId));
};
